import { IconEdit, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { uploadImage } from '../../../api/api.global';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const UpdateAgent = ({ agentData, callback }) => {

    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const [agentDetails, setAgentDetails] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getAgentDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.agentDetails + agentData._id);
        loadingHide();
        if (resp.responseCode === 200) {
            setAgentDetails(resp.data);
            handleShow();
        } else {
            toast.error(resp?.message);
        }
    }

    function fileOnChange(event) {
        let file = event.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            event.target.value = null;
        } else {
            setFile(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                document.getElementById('pic-preview').src = reader.result;
            }
        }
    }

    async function addAgent() {
        loadingShow();
        let localData = {
            "name": document.getElementById('name').value.trim(),
            "email": document.getElementById('email').value.trim(),
            "phone": document.getElementById('phone').value.trim(),
            "tdsPercent": document.getElementById('tdsPercent').value,
            "whatsappNumber": document.getElementById('whatsappNumber').value.trim(),
            "address": document.getElementById('address').value,
            "note": document.getElementById('note').value,
        }

        let postData = {
            name: localData.name,
            phone: localData.phone,
            tdsPercent: localData.tdsPercent,
            profilePic: file ? await uploadImage(file, "advy-agents-profile-pic") : agentData.profilePic,
            note: localData.note
        }

        if (localData?.email) {
            postData.email = localData.email
        }

        if (localData?.whatsappNumber) {
            postData.whatsappNumber = localData?.whatsappNumber
        }

        if (localData?.address) {
            postData.address = localData?.address
        }

        let resp = await postApi(postData, urlApi.agentUpdate + agentData?._id);
        loadingHide();
        if (resp.responseCode === 200) {
            callback?.();
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }


    return (
        <>
            <div className='max-w-max' onClick={getAgentDetails} ><button title='Edit Agent Details'> <IconEdit size={20} color='#9747FF' /> </button></div>

            <Modal show={show} onHide={handleClose} size='xl' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Update Agent</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <p className="text-sm font-semibold mb-2">Personal Details</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                        <div className="">
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Name*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='name' defaultValue={agentDetails?.name} />
                        </div>
                        <div className="">
                            <label htmlFor="phone" className='text-sm font-semibold mb-1'>Mobile Number*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='phone' maxLength={10} defaultValue={agentDetails?.phone} />
                        </div>
                        <div className="">
                            <label htmlFor="whatsappNumber" className='text-sm font-semibold mb-1'>WhatsApp Number</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='whatsappNumber' maxLength={10} defaultValue={agentDetails?.whatsappNumber} />
                        </div>
                        <div className="">
                            <label htmlFor="email" className='text-sm font-semibold mb-1'>Email</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='email' defaultValue={agentDetails?.email} />
                        </div>
                        <div className="col-span-2">
                            <label htmlFor="address" className='text-sm font-semibold mb-1'>Address</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='address' defaultValue={agentDetails?.address} ></textarea>
                        </div>
                        <div className="">
                            <label htmlFor="admin-profile-file" className='text-sm font-semibold mb-1'>Profile Picture (Max 5Mb)</label>
                            <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full px-3 py-2 rounded-md border-2 text-sm' accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <img src={agentDetails?.profilePic} alt="" id='pic-preview' className='max-h-[200px] max-w-full object-contain rounded-md mx-auto mt-4' />
                    </div>

                    <div className="max-h-80 overflow-y-auto">
                        <p className="text-sm font-semibold mb-2">Bank & Others Details</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div className="">
                                <label htmlFor="tdsPercent" className='text-sm font-semibold mb-1'>TDS*</label>
                                <select name="" id="tdsPercent" className='w-full px-3 py-2 rounded-md border-2 text-sm' defaultValue={agentDetails?.tdsPercent}>
                                    <option value="" disabled selected>Select TDS Status</option>
                                    <option value="1">1%</option>
                                    <option value="2">2%</option>
                                    <option value="10">10%</option>
                                    <option value="30">30%</option>
                                </select>
                            </div>
                            <div className="col-span-2">
                                <label htmlFor="note" className='text-sm font-semibold mb-1'>Note</label>
                                <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='note' maxLength={255} defaultValue={agentDetails?.note} ></textarea>
                            </div>
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => addAgent()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateAgent